import { defineStore } from 'pinia'
import { ref, computed } from 'vue'
import api from '../services/api'

const FAMILIA_TOKEN_KEY = 'familia_token'
const FAMILIA_USER_KEY = 'familia_user'

export const useFamiliaAuthStore = defineStore('familiaAuth', () => {
  const token = ref(localStorage.getItem(FAMILIA_TOKEN_KEY) || null)
  const usuario = ref(JSON.parse(localStorage.getItem(FAMILIA_USER_KEY) || 'null'))

  const isPaiAuthenticated = computed(() => !!token.value)
  const nomePai = computed(() => usuario.value?.nome || 'Pai')
  const iniciaisPai = computed(() => {
    const nome = usuario.value?.nome || ''
    return nome.split(' ').slice(0, 2).map(p => p[0]).join('').toUpperCase() || 'P'
  })

  function salvarSessao(novoToken, dados) {
    token.value = novoToken
    usuario.value = dados
    localStorage.setItem(FAMILIA_TOKEN_KEY, novoToken)
    localStorage.setItem(FAMILIA_USER_KEY, JSON.stringify(dados))
    // Sobrescreve o header padrão para garantir que o token do portal
    // tenha prioridade sobre qualquer token da cantina que esteja no header
    api.defaults.headers.common['Authorization'] = `Bearer ${novoToken}`
  }

  function limparSessao() {
    token.value = null
    usuario.value = null
    localStorage.removeItem(FAMILIA_TOKEN_KEY)
    localStorage.removeItem(FAMILIA_USER_KEY)
  }

  async function registrar({ nome, email, senha, telefone }) {
    const res = await api.post('/api/familia/auth/registrar', { nome, email, senha, telefone })
    if (res.data.success) {
      salvarSessao(res.data.token, res.data.usuario)
    }
    return res.data
  }

  async function login(email, senha) {
    const res = await api.post('/api/familia/auth/login', { email, senha })
    if (res.data.success) {
      salvarSessao(res.data.token, res.data.usuario)
    }
    return res.data
  }

  async function logout() {
    try {
      await api.post('/api/familia/auth/logout')
    } catch (_) {
      // ignora erros
    }
    limparSessao()
  }

  async function verificarToken() {
    if (!token.value) return false
    try {
      api.defaults.headers.common['Authorization'] = `Bearer ${token.value}`
      const res = await api.get('/api/familia/auth/me')
      usuario.value = res.data.usuario
      localStorage.setItem(FAMILIA_USER_KEY, JSON.stringify(res.data.usuario))
      return true
    } catch (_) {
      limparSessao()
      return false
    }
  }

  // Restaurar token ao iniciar
  if (token.value) {
    api.defaults.headers.common['Authorization'] = `Bearer ${token.value}`
  }

  return {
    token,
    usuario,
    isPaiAuthenticated,
    nomePai,
    iniciaisPai,
    login,
    registrar,
    logout,
    verificarToken,
    limparSessao,
  }
})
